<button
  type="button"
  class="collapse-header text-primary"
  [ngClass]="{
    'collapse-header--link btn-link btn': variant === 'link',
    'collapse-header--button': variant === 'button'
  }"
  [class.expanded]="open"
  (click)="openChange.emit()"
  [attr.aria-expanded]="open"
  [attr.aria-controls]="'collapseBasic-' + id"
  [attr.allytmln]="analyticsName? analyticsName : title"
  data-track-elem="accordion"
  [attr.data-track-name]="title"
  data-track-trigger="statechange"
  [attr.data-track-state]="open ? 'open' : 'closed'"
  [attr.aria-label]="open ? title + ' expanded' : title + ' collapsed'"
  attr.data-test-id="app-search-filter-section-e-accordian-button-{{tagName}}"
>
  <i class="allycon-glyph-caret-right collapse-header__icon" [class.expanded]="open" aria-hidden="true"></i>

  <span class="collapse-header__title ms-1">
    {{ title }}
  </span>
  <ng-content select="[title-right]"></ng-content>
</button>

<div
  [id]="'collapseBasic-' + id"
  class="collapse-body-wrap"
  [ngClass]="{
    'collapse-body-wrap--link': variant === 'link',
    'collapse-body-wrap--button': variant === 'button',
    'is-scrollable': scrollable
  }"
>
  <div class="collapse-body" [style.display]="open ? 'inherit' : 'none'">
    <ng-content></ng-content>
  </div>
</div>
